<a (click)="onItemClicked()" (keyup.enter)="onItemClicked()" [attr.tabindex]="getTabIndex()" class="ap-list-item__container">
    <ng-content></ng-content>
    <asn-icon
        [name]="getActionIcon()"
        [size]="actionType() === 'externalLink' ? 'medium' : 'small'"
        class="ap-list-item__action"
        [class.ap-list-item--disabled]="disabled()"
        data-testid="list-item-link-icon"
    ></asn-icon>
</a>
